module.exports = __webpack_public_path__ + "img/bank-enpara.c1aa9320.svg";